<div class="percentage-bar flex-column">
  <div class="flex-row justify-between align-start">
    <div class="percentage-bar-label">{{ label }}</div>
    <div class="percentage-bar-percentage">{{ percentage }}</div>
  </div>
  <mat-progress-bar mode="determinate" [value]="percentage"></mat-progress-bar>
</div>
